import {
  jb_cta_small_css_default
} from "./chunk.AG4MSSP4.js";
import {
  e
} from "./chunk.3XLWIJBS.js";
import {
  reset_css_default
} from "./chunk.LJHCRQCZ.js";
import {
  Linkable,
  getLinkIcon,
  jbLinkClickedEventToJbTrackingEvent
} from "./chunk.534YP5ZJ.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  isPartiallyInViewPort
} from "./chunk.JTCOOS2A.js";
import {
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  n,
  r
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-cta-small/jb-cta-small.ts
var JbCtaSmall = class extends Linkable(i) {
  constructor() {
    super(...arguments);
    this.alwaysVisible = false;
    this._ctaSmall = {
      el: null,
      hero: null,
      text: null,
      footer: null
    };
    this._expandedWidth = 0;
    this._isHovered = false;
    this._isVisible = false;
  }
  firstUpdated(changedProperties) {
    super.firstUpdated(changedProperties);
    this._ctaSmall.el = this.renderRoot.querySelector(".cta-small");
    this._ctaSmall.hero = document.querySelector(
      "jb-info-page-hero, jb-campaign-page-hero-fullscreen, jb-article-page-hero, jb-moment-page-hero, jb-news-page-hero, jb-simple-page-hero"
    );
    this._ctaSmall.text = this.renderRoot.querySelector(".text");
    this._ctaSmall.footer = document.querySelector("jb-footer");
    if (!this._ctaSmall.el) return;
    if (this.link.data.type === "download" && this.link?.href) {
      this._ctaSmall.el?.setAttribute("download", "");
    }
    this._expandedWidth = this.shadowRoot.querySelector("span")?.offsetWidth ?? 0;
    this._ctaSmall.el.addEventListener("mouseover", () => this._mouseOver());
    this._ctaSmall.el.addEventListener("mouseout", () => this._mouseOut());
    this._ctaSmall.el.addEventListener("focus", () => this._mouseOver());
    this._ctaSmall.el.addEventListener("focusout", () => this._mouseOut());
    window.addEventListener("scroll", () => this._showHide());
    setTimeout(() => {
      this._showHide();
    }, 0);
  }
  _aboveTheFold() {
    const viewportHeight = window.innerHeight;
    if (this._ctaSmall.hero) {
      const heroBottomEdgeOffset = this._ctaSmall.hero.getBoundingClientRect().bottom;
      return heroBottomEdgeOffset > viewportHeight / 2;
    }
    const scrollPosition = window.scrollY;
    return scrollPosition < viewportHeight / 2;
  }
  _mouseOut() {
    this._isHovered = false;
  }
  _mouseOver() {
    this._isHovered = true;
    this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
    this._ctaSmall.el?.setAttribute("aria-expanded", "true");
    setTimeout(() => {
      this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
    }, 200);
  }
  _nearBottom() {
    const buttonHeight = this._ctaSmall.el?.offsetHeight ?? 0;
    return window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - buttonHeight;
  }
  _showHide() {
    if (!this.alwaysVisible && (this._aboveTheFold() || this._ctaSmall.footer && isPartiallyInViewPort(this._ctaSmall.footer) || this._nearBottom())) {
      this._isVisible = false;
    } else {
      this._isVisible = true;
    }
  }
  _tracking(e2) {
    const jbTrackingEvent = jbLinkClickedEventToJbTrackingEvent(e2, {
      component_name: "cta-small",
      interaction_element: "cta"
    });
    if (jbTrackingEvent) {
      this.dispatchEvent(jbTrackingEvent);
    }
  }
  render() {
    return b`
      <a
        @jb-link:clicked=${this._tracking}
        data-linkable
        class="cta-small ${e({
      [this.link.data.type]: this.link.data.type,
      "cta-small--hover": this._isHovered,
      "cta-small--visible": this._isVisible
    })}"
        data-fly-tweak="0,0,${this._expandedWidth},-${this._expandedWidth + 8}"
      >
        <span
          class="text"
          data-fly-catcher
        >
          <span class="text-wrap">${this.text}</span>
        </span>
        <span class="icon">${getLinkIcon(this.link.data.type)}</span>
      </a>
    `;
  }
};
JbCtaSmall.styles = [reset_css_default, jb_cta_small_css_default];
__decorateClass([
  n({ type: Boolean })
], JbCtaSmall.prototype, "alwaysVisible", 2);
__decorateClass([
  n()
], JbCtaSmall.prototype, "text", 2);
__decorateClass([
  r()
], JbCtaSmall.prototype, "_isHovered", 2);
__decorateClass([
  r()
], JbCtaSmall.prototype, "_isVisible", 2);
JbCtaSmall = __decorateClass([
  customElement("jb-cta-small")
], JbCtaSmall);

export {
  JbCtaSmall
};
